const BASE_URL = process.env.REACT_APP_API_URL;

interface TwoFactorResponse {
    qrCodeUrl?: string;
    message?: string;
    success?: boolean;
    status?: number;
}

interface StatusResponse {
    status?: number;
}

const cookie = 'AWSALB=YoC8SpSSkHdrjEv0/ABsEMMHfg3oE86I/etkDylqiKZo0kLI4XTtpLeWGlbwDySr7AFF6snWUz7vtXZ3y6cVn2eOgLjqZHJBcEm95np8UJbNhqhTuxfreu0nVs+R; AWSALBCORS=YoC8SpSSkHdrjEv0/ABsEMMHfg3oE86I/etkDylqiKZo0kLI4XTtpLeWGlbwDySr7AFF6snWUz7vtXZ3y6cVn2eOgLjqZHJBcEm95np8UJbNhqhTuxfreu0nVs+R'

async function apiFetch<T>(endpoint: string, options: RequestInit): Promise<T | { status: number }> {
    try {
        const response = await fetch(`${BASE_URL}${endpoint}`, options);

        const contentType = response.headers.get("content-type");

        if (response.status === 204 || !contentType || !contentType.includes("application/json")) {
            return { status: response.status };
        }

        return (await response.json()) as T;
    } catch (error) {
        console.error("Erro ao acessar API:", error);
        throw error;
    }
}

export async function resetTwoFA(idSeller, token: string): Promise<TwoFactorResponse | { status: number }> {
    return await apiFetch<TwoFactorResponse | { status: number }>(`twofactor/reset?idSeller=${idSeller}`, {
        method: "PUT",
        headers: {
            "Authorization": `Bearer ${token}`,
            "Cookie": cookie,
        },
    });
}

export async function getTwoFactorStatus(idSeller: number, token: string): Promise<StatusResponse> {
    return await apiFetch<StatusResponse>(`twofactor/internal/status?idSeller=${idSeller}`, {
        method: "GET",
        headers: {
            "Authorization": `Bearer ${token}`,
            "Cookie": cookie,
        },

    });
}
